module.exports = __webpack_public_path__ + "static/analytics-workforce-management-75ac891b8b027f5bb135e3c8928d40d9.png";